import { Controller } from '@hotwired/stimulus'

const FIELDS = ['idp_entity_id', 'idp_sso_url', 'idp_cert'] as const

// Fills the IdP fields of an SSO connection form from its SAML metadata URL.
export default class extends Controller<HTMLFormElement> {
  static values = { url: String }
  static targets = ['url', 'button', 'status', ...FIELDS]

  declare urlValue: string
  declare urlTarget: HTMLInputElement
  declare buttonTarget: HTMLButtonElement
  declare statusTarget: HTMLElement

  async fetch (): Promise<void> {
    const url = this.urlTarget.value.trim()
    if (url === '') {
      this.report('Enter the metadata URL first.', true)
      return
    }

    this.buttonTarget.disabled = true
    this.report('Fetching metadata…', false)

    try {
      const response = await fetch(`${this.urlValue}?${new URLSearchParams({ url }).toString()}`, {
        headers: { Accept: 'application/json' }
      })
      const data = await response.json() as Record<string, string | null>
      if (!response.ok) throw new Error(data.error ?? response.statusText)

      for (const field of FIELDS) {
        const value = data[field]
        if (value != null && value !== '') this.field(field).value = value
      }
      this.report('Prefilled from the metadata. Review the fields, then save.', false)
    } catch (error) {
      this.report(`Could not fetch metadata: ${(error as Error).message}`, true)
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  private field (name: typeof FIELDS[number]): HTMLInputElement | HTMLTextAreaElement {
    return this.targets.find(name) as HTMLInputElement | HTMLTextAreaElement
  }

  private report (message: string, error: boolean): void {
    this.statusTarget.textContent = message
    this.statusTarget.classList.toggle('text-red-600', error)
    this.statusTarget.classList.toggle('text-gray-500', !error)
  }
}
